import { render } from "./geoChart.vue?vue&type=template&id=bc0484bc"
import script from "./geoChart.vue?vue&type=script&lang=js"
export * from "./geoChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__